import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface QuoteBlockRendererProps {
  block: { settings: Record<string, any> };
  config: TemplateConfig;
}

function hexToRgba(hex: string, alpha: number): string {
  let h = hex.trim();
  if (h.startsWith('#')) h = h.slice(1);
  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('');
  }
  if (h.length !== 6 || !/^[0-9a-fA-F]{6}$/.test(h)) {
    return `rgba(0, 0, 0, ${alpha})`;
  }
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

const QuoteBlockRenderer: React.FC<QuoteBlockRendererProps> = ({ block, config }) => {
  const s = block.settings;
  const text = String(s.text ?? '');
  const fontSize =
    typeof s.fontSize === 'number' && Number.isFinite(s.fontSize)
      ? s.fontSize
      : config.fontBoyutu;
  const borderColor =
    typeof s.borderColor === 'string' ? s.borderColor : config.aksanRenk;
  const bgColor =
    typeof s.bgColor === 'string' ? s.bgColor : hexToRgba(config.aksanRenk, 0.1);

  return (
    <div
      style={{
        fontFamily: config.font,
        fontSize,
        fontWeight: 400,
        color: '#2d2d2d',
        lineHeight: 1.55,
        whiteSpace: 'pre-wrap',
        backgroundColor: bgColor,
        borderLeft: `4px solid ${borderColor}`,
        borderRadius: 4,
        padding: '12px 16px',
        margin: 0,
      }}
    >
      {text}
    </div>
  );
};

export default QuoteBlockRenderer;
